import React from 'react';

import randomstring from 'uuid/v4';

import TextField from '@material-ui/core/TextField';
import AttachFile from '@material-ui/icons/AttachFile';
import Timer from '@material-ui/icons/Timer';
import Reply from '@material-ui/icons/Reply';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Send from '@material-ui/icons/Send';
import Close from '@material-ui/icons/Close';
import PermIdentity from '@material-ui/icons/PermIdentity';

import { timeDiference, getCurrentTime } from '../../../functions/time';

import PopupAnswer from './PopupAnswer';
import ProtectedImg from './ProtectedImg';

class DetailMessage extends React.Component {
    state = {
        param: undefined,
        message: undefined,
        comentario: '',
        answer: '',
        openAnswer: false,
    };

    static getDerivedStateFromProps(props, state) {
        const { param, message } = props;
        if (param !== state.param) {
            state.param = param;
            props.loadInfoMessage(param);
            return state;
        } else if (message !== state.message && message.id && message.id.toString() === param.toString()) {
            state.message = message;
            return state;
        }
        return null;
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleOpenPopupAnswer = (event) => {
        this.setState({ openAnswer: true });
    };

    handleClosePopupAnswer = (send, answer) => (event) => {

        if (send) {
            this.props.answerMessage({ id: this.state.message.id, respuesta: answer })
                .then(() => {
                    this.props.loadInfoMessage(this.props.param);
                })
                .catch((error) => {
                    this.props.showError(error.message, error.type);
                })
        }
        this.setState({ openAnswer: false });

    };

    exit = () => {
        this.props.history.push('/communications/receive');
    }


    handleSave = (event) => {

        this.props.saveMessage({ id: this.state.message.id })
            .then(() => {
                this.props.history.push('/communications/receive');
            })
            .catch((error) => {
                this.props.showError(error.message, error.type);
            })

    }


    handleReply = (event) => {

        if (this.state.comentario) {

            this.props.sendCommunicationMessage({ id: this.state.message.id, mensaje: this.state.comentario })
                .then(() => {
                    this.setState({ comentario: '' });
                })
                .catch((error) => {
                    this.props.showError(error.message, error.type);
                })

        }

    }

    render() {
        const { message, comentario, openAnswer } = this.state;
        const { intl } = this.props;

        console.log('render detailmessage');

        return (
            <div className={'flex_50 bg_white detail_communications overflow_y_scroll showbar'}>
                {openAnswer && (
                    <PopupAnswer {...this.props} onClose={this.handleClosePopupAnswer} id={message.id} />
                )}
                {(message &&
                    message.requiereRespuesta > 0 &&
                    !message.respuesta) && (
                        <div
                            className={
                                'flex_auto_row align_center padding_borders ' +
                                (message.prioridad === 1 ? ' bg_lipstick' : 'bg_bluish')
                            }
                        >
                            <div className={'flex_full_row center uppercase c_white'}>
                                {message.prioridad === 1
                                    ? intl.formatMessage({ id: 'communication_text_urgent' })
                                    : intl.formatMessage({
                                        id: 'communication_text_answer_required',
                                    })}
                            </div>
                            {
                                (timeDiference(message.limite, getCurrentTime()) !== '00 s') &&
                                <div className="flex_auto_row align_center nowrap">
                                    <Timer className="c_white margin_right_2 communications_icon" />
                                    <span className="flex_auto_row barlow_regular_small c_white margin_right_2">
                                        {intl.formatMessage({ id: 'communication_remaining_time' })}
                                    </span>
                                    <p className="flex_auto_row barlow_regular_small c_white">
                                        {message.limite.substring(0, message.limite.length - 3)}
                                    </p>
                                </div>
                            }
                        </div>
                    )}
                {message && (
                    <div className={'flex_full_column padding_borders_flat'}>
                        <div className="flex_auto_row align_center margin_top_24">
                            <div className="flex_full_row align_center ">
                                {message.estado === 0 && (
                                    <div className="button-message barlow_regular_small c_pea border_pea">
                                        {intl.formatMessage({ id: 'communication_text_new' })}
                                    </div>
                                )}
                                {message.estado === 1 && (
                                    <div className="button-message barlow_regular_small c_disabled border_disabled">
                                        {intl.formatMessage({ id: 'communication_readed' })}
                                    </div>
                                )}
                                {message.estado === 2 && (
                                    <div className="button-message barlow_regular_small c_bluish border_bluish">
                                        {intl.formatMessage({ id: 'communication_answered' })}
                                    </div>
                                )}
                                {message.estado === 3 && (
                                    <div className="button-message barlow_regular_small c_disabled border_disabled">
                                        {intl.formatMessage({ id: 'communication_saved' })}
                                    </div>
                                )}
                                {message.prioridad === 1 && (
                                    <div className="button-message barlow_regular_small c_lipstick border_lipstick">
                                        {intl.formatMessage({ id: 'communication_text_urgent' })}
                                    </div>
                                )}
                            </div>

                            {(message.requiereRespuesta === 1 && !message.respuesta) && (
                                <div
                                    className="button-send align_center flex_auto_row hand margin_right_6 nowrap"
                                    onClick={this.handleOpenPopupAnswer}
                                >
                                    <Send className="c_bluish margin_right_6 " />
                                    {intl.formatMessage({ id: message.respuestaPrevia ? 'communication_sent_add_answer' : 'communication_sent_answer' })}
                                </div>
                            )}
                            {(message.requiereRespuesta === 2 && !message.respuesta) && (
                                <div
                                    className="button-send align_center flex_auto_row hand margin_right_6 nowrap"
                                    onClick={this.handleOpenPopupAnswer}
                                >
                                    <Send className="c_bluish margin_right_6 " />
                                    {intl.formatMessage({ id: message.respuestaPrevia ? 'communication_sent_add_answer' : 'communication_sent_answer' })}
                                </div>
                            )}
                            {(message.requiereRespuesta === 0 || message.requiereRespuesta === 1) && (
                                <div
                                    className="button-save align_center flex_auto_row margin_right_6 hand"
                                    onClick={this.handleSave}
                                >
                                    <SaveAlt className="c_disabled margin_right_6" />
                                    {intl.formatMessage({ id: 'communication_save' })}
                                </div>
                            )}
                            {(message.requiereRespuesta === 2 && (!!message.respuesta || !!message.respuestaPrevia)) && (
                                <div
                                    className="button-save align_center flex_auto_row margin_right_6 hand"
                                    onClick={this.handleSave}
                                >
                                    <SaveAlt className="c_disabled margin_right_6" />
                                    {intl.formatMessage({ id: 'communication_save' })}
                                </div>
                            )}
                            {(message.requiereRespuesta === 3 && !message.respuesta) && (
                                <div
                                    className="button-send align_center flex_auto_row hand margin_right_6 nowrap"
                                    onClick={this.handleOpenPopupAnswer}
                                >
                                    <Send className="c_bluish margin_right_6 " />
                                    {intl.formatMessage({ id: message.respuestaPrevia ? 'communication_sent_add_answer' : 'communication_sent_answer' })}
                                </div>
                            )}
                            {(message.requiereRespuesta === 3 && !!message.respuesta) && (
                                <div
                                    className="button-save align_center flex_auto_row margin_right_6 hand"
                                    onClick={this.handleSave}
                                >
                                    <SaveAlt className="c_disabled margin_right_6" />
                                    {intl.formatMessage({ id: 'communication_save' })}
                                </div>
                            )}
                            <Close className="c_disabled margin_left_6 margin_right_6 hand" onClick={this.exit} />
                        </div>
                        <div className="flex_auto_row align_center margin_top_24">
                            <span className="flex_full_row  barlowsemicondensed_bold c_slate">
                                {message.asunto}
                            </span>
                        </div>
                        <div className="flex_full_row margin_top_8">
                            <span className="flex_auto_row barlow_regular_small c_cool_grey margin_right_2">{intl.formatMessage({ id: 'communication_text_sent' })}</span>
                            <span className="flex_auto_row barlow_semibold_small c_bluish margin_right_6">{message.enviadaPor}</span>
                        </div>
                        {message.enviada && (
                            <div className="flex_auto_row align_center margin_top_8">
                                <p className="flex_full_row barlow_italic_medium c_disabled">
                                    {message.enviada}
                                </p>
                            </div>
                        )}
                        {message.limite && (
                            <div className="flex_auto_row align_center">
                                <Timer className="c_disabled margin_right_2 communications_icon" />
                                <span className="flex_auto_row barlow_regular_small c_cool_grey margin_right_2">
                                    {intl.formatMessage({ id: 'communication_remaining_time' })}
                                </span>
                                <p className="flex_auto_row barlow_regular_small c_slate">
                                    {message.limite.substring(0, message.limite.length - 3)}
                                </p>
                            </div>
                        )}
                        <div className="flex_auto_column margin_top_8">
                            <p className="flex_full_row barlow_regular_small c_slate">
                                {intl.formatMessage({ id: 'form_field_description' })}
                            </p>
                            <div
                                className="flex_full_row bg_black_6 shadow_left_only ql-editor-show "
                                dangerouslySetInnerHTML={{ __html: message.cuerpo }}
                            ></div>
                        </div>
                        <div className="flex_auto_column margin_top_8">
                            <div className="flex_auto_row align_center">
                                <AttachFile className="c_disabled margin_right_2 communications_icon" />
                                <p className="flex_full_row barlow_regular_small c_slate">
                                    {intl.formatMessage({ id: 'attach' })}
                                </p>
                            </div>
                            <div className="flex_auto_column margin_top_8">
                                {message.adjuntosComunicacion.length > 0 &&
                                    message.adjuntosComunicacion.map((a) => {
                                        return (
                                            <ProtectedImg
                                                {...this.props}
                                                key={`thumbnail-${message.id}-${a.id}`}
                                                communication={true}
                                                id={a.id}
                                                name={a.nombre}
                                                parent={message.id}
                                                src={`${process.env.REACT_APP_API_MESSAGES}/${message.id}/adjunto/${a.id}/miniatura?token=${sessionStorage.token.replace('Bearer ', '')}`}
                                                download={`${process.env.REACT_APP_API_MESSAGES}/${message.id}/adjunto/${a.id}/datos/${a.nombre}?token=${sessionStorage.token.replace('Bearer ', '')}`}
                                            />)
                                    })
                                }
                            </div>
                        </div>
                        {message.respuestaPrevia &&
                            <div className="flex_auto_column">
                                <div className="flex_auto_column margin_top_8">
                                    <div className="flex_auto_row align_center">
                                        <p className="flex_auto_row barlow_regular_small c_slate nowrap margin_left_32">
                                            {intl.formatMessage({ id: 'communication_previous_answer' })}
                                        </p>
                                        <p className="flex_full_row barlow_regular_small c_bluish elements_from_right">
                                            <PermIdentity className="c_bluish padding_right_6" />
                                            {message.respuestaPreviaRemitente}
                                        </p>
                                    </div>

                                    <div
                                        className="flex_full_row bg_black_6 shadow_left_only ql-editor-show margin_left_32"
                                        dangerouslySetInnerHTML={{ __html: message.respuestaPrevia }}
                                    ></div>
                                </div>
                                <div className="flex_auto_column margin_top_8 margin_left_32">
                                    <div className="flex_auto_row align_center">
                                        <AttachFile className="c_disabled margin_right_2 communications_icon" />
                                        <p className="flex_full_row barlow_regular_small c_slate">
                                            {intl.formatMessage({ id: 'attach' })}
                                        </p>
                                    </div>
                                    {message.respuestaPreviaAdjuntos &&
                                        <div className="flex_auto_column margin_top_8">
                                            {message.respuestaPreviaAdjuntos.length > 0 &&
                                                message.respuestaPreviaAdjuntos.map((a) => {
                                                    return (
                                                        <ProtectedImg
                                                            {...this.props}
                                                            key={`thumbnail-${message.id}-${a.id}`}
                                                            communication={false}
                                                            id={a.id}
                                                            name={a.nombre}
                                                            parent={message.id}
                                                            src={`${process.env.REACT_APP_API_MESSAGES}/${message.id}/adjunto/${a.id}/miniatura?token=${sessionStorage.token.replace('Bearer ', '')}`}
                                                            download={`${process.env.REACT_APP_API_MESSAGES}/${message.id}/adjunto/${a.id}/datos/${a.nombre}?token=${sessionStorage.token.replace('Bearer ', '')}`}
                                                        />)
                                                })
                                            }
                                        </div>
                                    }
                                </div>

                            </div>
                        }
                        {message.respuesta &&
                            <div className="flex_auto_column">
                                <div className="flex_auto_column margin_top_8">
                                    <div className="flex_auto_row align_center">
                                        <p className="flex_full_row barlow_regular_small c_slate margin_left_32">
                                            {intl.formatMessage({ id: 'communication_answer' })}
                                        </p>
                                    </div>

                                    <div
                                        className="flex_full_row bg_black_6 shadow_left_only ql-editor-show margin_left_32"
                                        dangerouslySetInnerHTML={{ __html: message.respuesta }}
                                    ></div>
                                </div>
                                <div className="flex_auto_column margin_top_8 margin_left_32">
                                    <div className="flex_auto_row align_center">
                                        <AttachFile className="c_disabled margin_right_2 communications_icon" />
                                        <p className="flex_full_row barlow_regular_small c_slate">
                                            {intl.formatMessage({ id: 'attach' })}
                                        </p>
                                    </div>
                                    <div className="flex_auto_column margin_top_8">
                                        {message.adjuntos.length > 0 &&
                                            message.adjuntos.map((a) => {
                                                console.log(a);
                                                return (
                                                    <ProtectedImg
                                                        {...this.props}
                                                        key={`thumbnail-${message.id}-${a.id}`}
                                                        communication={false}
                                                        id={a.id}
                                                        parent={message.id}
                                                        name={a.nombre}
                                                        src={`${process.env.REACT_APP_API_MESSAGES}/${message.id}/adjunto/${a.id}/miniatura?token=${sessionStorage.token.replace('Bearer ', '')}`}
                                                        download={`${process.env.REACT_APP_API_MESSAGES}/${message.id}/adjunto/${a.id}/datos/${a.nombre}?token=${sessionStorage.token.replace('Bearer ', '')}`}
                                                    />)
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="flex_auto_column margin_top_8">
                            <div className="flex_auto_row align_center">
                                <div className={'bubbly margin_right_6'}>
                                    {message.comentarios.length}
                                </div>
                                <p className="flex_full_row barlow_regular_small c_slate">
                                    {intl.formatMessage({ id: 'form_field_comment' })}
                                </p>
                            </div>
                            {message.comentarios && message.comentarios.length > 0 && (
                                <ul className="padding_left_24 margin_bottom_5">
                                    {message.comentarios.map((c) => {
                                        return (
                                            <li
                                                key={randomstring()}
                                                className="communication-comments-point flex_auto_column"
                                            >
                                                <div className="flex_auto_row align_center">
                                                    <span className="flex_full_row barlowsemicondensed_semibold_link c_bluish">
                                                        {c.remitente}
                                                    </span>
                                                    <span className="flex_auto_row barlow_regular_subtitle_small c_disabled nowrap">
                                                        {c.fecha}
                                                    </span>
                                                </div>
                                                <div className="flex_auto_row barlow_regular_subtitle margin_bottom_24 c_slate margin_top_8">
                                                    {c.mensaje}
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                            <div className="flex_auto_row padding_left_24 align_center">
                                <TextField
                                    id="comentario"
                                    name="comentario"
                                    label={intl.formatMessage({ id: 'comments_drawer' })}
                                    fullWidth
                                    className="margin_bottom_12 padding_top_24"
                                    value={comentario}
                                    onChange={this.handleChange}
                                />
                                <Reply className="c_bluish margin_left_6 hand" onClick={this.handleReply} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default DetailMessage;



// WEBPACK FOOTER //
// ./src/components/complex/communications/DetailMessage.js